import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  selectClientTabIsSaving,
  selectClientTabJustSaved,
  selectClientTabUnsavedChangesCount,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

interface SaveState {
  isSaving: boolean
  unsavedCount: number
  justSaved: boolean
}

const statusKeyOf = ({ isSaving, unsavedCount, justSaved }: SaveState) => {
  if (isSaving) return 'saving'
  if (unsavedCount > 0) return 'unsaved'
  if (justSaved) return 'saved'
  return 'none'
}

const useClientSaveStatus = () => {
  const { t } = useTranslation()
  const isSaving: boolean = useSelector(selectClientTabIsSaving)
  const unsavedCount: number = useSelector(selectClientTabUnsavedChangesCount)
  const justSaved: boolean = useSelector(selectClientTabJustSaved)
  const statusKey = statusKeyOf({ isSaving, unsavedCount, justSaved })

  return {
    statusText: t(`subscriptionForm:client_tab.status.${statusKey}`, { count: unsavedCount }),
    hasUnsavedChanges: statusKey === 'unsaved',
  }
}

export default useClientSaveStatus
